import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

Vue.use(VueI18n)

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
}

// 获取浏览器语言设置
const getDefaultLocale = () => {
  // 首先检查URL参数
  const urlParams = new URLSearchParams(window.location.search)
  const urlLang = urlParams.get('lang')
  if (urlLang && messages[urlLang]) {
    localStorage.setItem('locale', urlLang)
    return urlLang
  }

  // 检查本地存储的语言设置
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && messages[savedLocale]) {
    return savedLocale
  }

  // 检查浏览器语言设置，优先支持中文
  const browserLang = navigator.language || navigator.userLanguage || ''
  const browserLangs = navigator.languages || [browserLang]
  
  // 检查所有浏览器语言设置
  for (const lang of browserLangs) {
    const lowerLang = lang.toLowerCase()
    
    // 详细检测中文各种变体
    if (lowerLang.startsWith('zh') || 
        lowerLang.includes('cn') ||
        lowerLang === 'zh-hans' || 
        lowerLang === 'zh-hant' ||
        lowerLang === 'zh-tw' || 
        lowerLang === 'zh-hk' || 
        lowerLang === 'zh-mo' ||
        lowerLang === 'zh-sg' ||
        lowerLang === 'zh-cn' ||
        lowerLang === 'zh-chs' ||
        lowerLang === 'zh-cht') {
      return 'zh-CN'
    }
    
    // 检测英文
    if (lowerLang.startsWith('en')) {
      return 'en-US'
    }
  }

  // 检查用户地理位置（如果可用）
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (timezone && (timezone.includes('Shanghai') || 
                     timezone.includes('Beijing') || 
                     timezone.includes('Chongqing') || 
                     timezone.includes('Hong_Kong') ||
                     timezone.includes('Taipei') ||
                     timezone.includes('Macau'))) {
      return 'zh-CN'
    }
  } catch (e) {
    // 忽略时区检测错误
  }

  // 默认返回中文（因为主要面向中文用户）
  return 'zh-CN'
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-CN', // 改为中文作为备用语言
  messages
})

// 监听语言变化并保存到本地存储
i18n.vm.$watch('locale', (newLocale) => {
  localStorage.setItem('locale', newLocale)
  // 更新HTML lang属性
  document.documentElement.lang = newLocale
  // 更新页面URL（可选）
  if (window.history && window.history.replaceState) {
    const url = new URL(window.location)
    url.searchParams.set('lang', newLocale)
    window.history.replaceState({}, '', url.toString())
  }
})

export default i18n
